import dom from '../../utils/dom';


const ComponentKeys = {
  CART: 'aa1924f3-4985-41ce-aab1-77e385f42ecc',
  EVENTS_LISTING_PAGE: 'a349395d-5724-4fba-8bc7-904f10f1e2ed',
  EVENTS_LISTING_FILTER: 'd6aea9cb-dd4e-473e-8bf7-59f66d231113',
  UTILITY_NAVIGATION: '2e16b93d-fa49-4b05-b981-9897dc177655',
  FLEX_PACKAGES_MINI_CART: '2b73dbf9-c487-471a-b377-3bdad62b7a8e',
  PACKAGES: '1a095c36-8460-4ba8-8cc2-965406082df8',
  SHIPPING: 'acb62880-d783-44fc-aca7-ddecf4ad2efb',
  ADDRESS_VERIFICATION_SERVICE: '4eb965d0-5d51-455f-95e4-4e64630f5465',
  SYOS: '3029c6e5-7933-4c14-a29b-ccde223c6176',
  UPDATE_PASSWORD: 'cca58df1-1de2-4c0a-8fea-d212a282f5b4',
  FORGOT_PASSWORD: 'cac7e136-b8dc-4969-854a-45adc14395d1',
  PAYMENT_PLANS: 'dfb4314b-c2b9-4069-93c9-d1e0d062526f',
};


function findElement(componentKey, propertyName) {
  const selector = `[data-tn-component-property="${componentKey}_${propertyName}"]`;

  const $el = dom.find(selector);

  if (!$el) {
    throw new Error(`Requested component property not found.\n\r\n\rComponent: ${componentKey}\n\rProperty: ${propertyName}\r`);
  }

  return $el;
}


/**
 * @param {string} componentKey
 * @param {string} propertyName
 */
function get(componentKey, propertyName) {
  const $el = findElement(componentKey, propertyName);

  return $el.innerHTML;
}

/**
 * @param {string} componentKey
 * @param {string} propertyName
 */
function getValue(componentKey, propertyName) {
  const $el = findElement(componentKey, propertyName);

  const $wrapper = dom.findFrom($el, '[data-tn-field]');

  if ($wrapper) {
    return $wrapper.innerHTML;
  }

  return $el.innerHTML;
}

export default {
  get,
  getValue,
};

export { ComponentKeys };



// WEBPACK FOOTER //
// ./V7/tnew/content/ContentStorage.js